/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/FollowAuthor/theme';

export const FollowAuthorTheme = theme;
